export const faqData = [
    {
        id: "01",
        question:
            "How do we handle platform-specific features?",
        answer:"Since we’re adept at native application development as well, our teams collaboratively implement platform channels and native modules. This ensures your app can leverage platform-specific native libraries and APIs (like BLE, NFC, or advanced sensors) to perform optimally on both iOS and Android devices."
    }, 
    {
        id: "02",
        question:
            "Does a cross-platform approach ensure a production-grade application for both app stores?",
        answer:"Absolutely. We build lean, high-performance apps that punch above their weight. By addressing UX debt and other risks beforehand, we deliver production-ready software that meets the strict quality standards of the Apple App Store and Google Play."
    }, 
    {
        id: "03",
        question:
            "Are there any limitations with external API integrations?",
        answer:"Cross-platform frameworks like Flutter and React Native support most REST, GraphQL, and WebSocket APIs out of the box. For advanced cases, such as background services or real-time hardware-level communication, we implement custom native bridges to ensure seamless connectivity."
    }, 
    {
        id: "04",
        question:
            "How much time and cost will I actually save compared to native development?",
        answer:"Typically, our clients see a 30–70% reduction in development costs because we manage a single codebase instead of two. This unified approach also accelerates your timeline, allowing you to launch a high-quality MVP on both platforms months sooner than a traditional dual-native track."
    }, 
    {
        id: "05",
        question:
            "Will I regret choosing cross-platform for long-term maintenance?",
        answer:"Quite the opposite, a single codebase is significantly easier to future-proof than two separate ones. We focus on clean architecture and high code quality to avoid dependency issues, making it simpler to sync new features, roll out security updates, and maintain the app as mobile operating systems evolve."
    }, 
  

];